"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaturePad = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const useSignaturePad_1 = require("./useSignaturePad");
const SignatureCanvas_1 = require("./SignatureCanvas");
const SignaturePad = (_a) => {
    var { onChange, value, children, readOnly } = _a, styles = (0, tslib_1.__rest)(_a, ["onChange", "value", "children", "readOnly"]);
    const { ref, clearSignature, setSignature } = (0, useSignaturePad_1.useSignaturePad)({
        onChange,
        value,
        readOnly
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SignatureCanvas_1.SignatureCanvas, Object.assign({}, styles, { readOnly: readOnly, canvasRef: ref }), void 0), children ? children({ clearSignature, setSignature }) : null] }, void 0));
};
exports.SignaturePad = SignaturePad;
//# sourceMappingURL=SignaturePad.js.map